import { render, staticRenderFns } from "./vehicleMaster.vue?vue&type=template&id=2a655048"
import script from "./vehicleMaster.vue?vue&type=script&lang=js"
export * from "./vehicleMaster.vue?vue&type=script&lang=js"
import style0 from "./vehicleMaster.vue?vue&type=style&index=0&id=2a655048&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports